import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

// URL and endpoint constants
const API_URL = process.env.API_BASE_URL

const getPermissoesUnidades = () => {
  const PERMISSOES_URL = API_URL + '/permissoes-unidades'
  let config = {
    method: 'get',
    url: PERMISSOES_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const getBolsa = (idBolsa) => {
  const BOLSA_URL = API_URL + '/bolsas/' + idBolsa
  let config = {
    method: 'get',
    url: BOLSA_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const getBolsas = () => {
  const BOLSAS_URL = API_URL + '/bolsas'
  let config = {
    method: 'get',
    url: BOLSAS_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const getBolsasGerenciadas = () => {
  const BOLSAS_GERENCIADAS_URL = API_URL + '/bolsas'
  let config = {
    method: 'get',
    url: BOLSAS_GERENCIADAS_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const postBolsa = (idUnidade, bolsa) => {
  const BOLSAS_URL = API_URL + '/unidades/' + idUnidade + '/bolsas'
  let config = {
    method: 'post',
    url: BOLSAS_URL,
    responseType: 'json',
    credentials: true,
    body: bolsa
  }
  return Vue.http(config)
}

const putAlocacao = (idBolsa, idProjeto, quantidade) => {
  const ALOCACAO_URL = API_URL + '/bolsas/' + idBolsa + '/projetos/' + idProjeto
  let config = {
    method: 'put',
    url: ALOCACAO_URL,
    responseType: 'json',
    credentials: true,
    body: {quantidade: quantidade}
  }
  return Vue.http(config)
}

const getFrequencias = (idProjeto, idParticipante) => {
  const FREQUENCIA_URL = API_URL + '/projetos/' + idProjeto + '/participantes/' + idParticipante + '/frequencia'
  let config = {
    method: 'get',
    url: FREQUENCIA_URL,
    responseType: 'json',
    credentials: true
  }
  return Vue.http(config)
}

const postFrequencia = (idProjeto, idParticipante, frequencia) => {
  const FREQUENCIA_URL = API_URL + '/projetos/' + idProjeto + '/participantes/' + idParticipante + '/frequencia'
  let config = {
    method: 'post',
    url: FREQUENCIA_URL,
    responseType: 'json',
    credentials: true,
    body: frequencia
  }
  return Vue.http(config)
}

const getPeriodoFrequencia = () => {
  const FREQUENCIA_URL = API_URL + '/periodo-frequencia'
  let config = {
    method: 'get',
    url: FREQUENCIA_URL,
    responseType: 'json',
    credentials: true
  }
  return Vue.http(config)
}

const postPeriodoFrequencia = (periodoFrequencia) => {
  const FREQUENCIA_URL = API_URL + '/periodo-frequencia'
  let config = {
    method: 'post',
    url: FREQUENCIA_URL,
    responseType: 'json',
    credentials: true,
    body: periodoFrequencia
  }
  return Vue.http(config)
}

const getBolsista = () => {
  const URL = API_URL + '/bolsista'
  let config = {
    method: 'get',
    url: URL,
    responseType: 'json',
    credentials: true
  }
  return Vue.http(config)
}

export default {
  getPermissoesUnidades,
  getBolsa,
  getBolsas,
  getBolsasGerenciadas,
  postBolsa,
  putAlocacao,
  getFrequencias,
  postFrequencia,
  getPeriodoFrequencia,
  postPeriodoFrequencia,
  getBolsista
}



// WEBPACK FOOTER //
// ./src/utils/bolsas.js